import { useEffect, useState } from "react";
import { Col, Row, Form, Input, Button, Card, Typography, message } from "antd";
import { SendOutlined } from "@ant-design/icons";
import axios from "axios";
import styles from "./retailerQuery.module.scss";
import { apiUrl } from "../../../../Constant";

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

function RetailerQuery() {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onFinish = async (values) => {
    try {
      setSubmitting(true);
      const res = await axios.post(apiUrl.ADD_RETAILER_QUERY, values);
      if (res?.data?.type === "success") {
        message.success("Thanks! Your retailer query has been submitted.");
        form.resetFields();
      } else {
        message.error(res?.data?.message || "Failed to submit query.");
      }
    } catch (error) {
      message.error("Failed to submit query. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.queryContainer}>
      <Row justify="center">
        <Col xs={22} xl={18}>
          <div className={styles.headerSection}>
            <Title level={1}>Retailer Queries</Title>
            <Paragraph className={styles.subTitle}>
              Partner with The Diamond Counter. Tell us about your business and
              we’ll get back to you shortly.
            </Paragraph>
          </div>

          <Card className={styles.formCard} bordered={false}>
            <Form form={form} layout="vertical" onFinish={onFinish} size="large">
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Full Name"
                    name="name"
                    rules={[{ required: true, message: "Please enter your name" }]}
                  >
                    <Input placeholder="John Doe" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Registered Business Name"
                    name="companyName"
                    rules={[
                      { required: true, message: "Please enter company name" },
                    ]}
                  >
                    <Input placeholder="Business Name" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                  >
                    <Input placeholder="john@example.com" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Phone" name="phone">
                    <Input placeholder="+44 000 0000" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item label="Country" name="country">
                    <Input placeholder="United Kingdom" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Website" name="website">
                    <Input placeholder="https://yourstore.com" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                label="Message"
                name="message"
                rules={[
                  { required: true, message: "Please enter your message" },
                ]}
              >
                <TextArea rows={5} placeholder="Tell us about your business..." />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SendOutlined />}
                  className={styles.submitBtn}
                  block
                  loading={submitting}
                >
                  Submit Query
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default RetailerQuery;
